import { CoordinatorService } from './coordinator.service';
import { Stage } from './stage';

export class Keyboard$ {
    constructor(public coords: CoordinatorService) {}

    keyup(event: KeyboardEvent) {
        if (!this.coords.project$.current) return;

        const target = event.target as HTMLElement;
        if (target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA')) return;

        const meta = event.metaKey;
        const ctrl = event.ctrlKey;
        const alt = event.altKey;
        const shift = event.shiftKey;

        // if (event.key === 'Escape') {
        //     return this.coords.display$.closeDialog()
        // }
        if (!(ctrl || meta || alt)) return this.key(event.key);
        // console.log(event.key, event)
    }

    key(char: string) {
        const st = this.coords.stage$.current!;
        switch (char) {
            case 'c':
                return this.key_c(st);
            case 'n':
                return this.key_n(st);
            case 'p':
                return this.key_p(st);
            case 'r':
                return this.key_r(st);
            case 'k':
                return this.key_k(st);
            // default:
            //     console.log(222, char)
        }
    }

    key_k(st: Stage) {
        switch (st.tag) {
            case 'collection':
            case 'preview':
                return this.coords.keyword$.edit(undefined, this.coords.resultList$.activeItem);
        }
    }

    key_c(st: Stage) {
        switch (st.tag) {
            case 'preview':
                if (this.coords.dataset$.isSingleItemMode)
                    this.coords.view$.to('main', this.coords.resultList$.activeItem!);
                return;
        }
    }

    key_r(st: Stage) {
        switch (st.tag) {
            case 'preview':
                if (this.coords.dataset$.isSingleItemMode)
                    this.coords.view$.to('__rejected', this.coords.resultList$.activeItem!);
                return;
        }
    }

    key_n(st: Stage) {
        switch (st.tag) {
            case 'collection':
            case 'preview':
                return this.coords.resultList$.step();
        }
    }

    key_p(st: Stage) {
        switch (st.tag) {
            case 'collection':
            case 'preview':
                return this.coords.resultList$.step(true);
        }
    }
}
